/* Bijoumani Atelier — thème Shopify
   Convertit app.js / home.js de la maquette : plus de catalogue embarqué (CAT),
   tout passe par Liquid + l'API AJAX de Shopify (panier, produits, recherche prédictive). */
(() => {
  'use strict';
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const B = window.BJM || { routes: {} };
  const R = B.routes || {};
  const html = document.documentElement;
  const mobile = matchMedia('(max-width: 900px)');
  const reduce = matchMedia('(prefers-reduced-motion: reduce)');
  const store = {
    get(k, d) { try { const v = localStorage.getItem(k); return v == null ? d : JSON.parse(v); } catch (e) { return d; } },
    set(k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }
  };
  const fmt = new Intl.NumberFormat(html.lang || 'fr', { style: 'currency', currency: B.currency || 'EUR' });
  const money = cents => fmt.format((cents || 0) / 100);
  const esc = s => String(s == null ? '' : s).replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const IC = {
    plus: '<svg viewBox="0 0 24 24"><path d="M12 5v14M5 12h14"/></svg>',
    minus: '<svg viewBox="0 0 24 24"><path d="M5 12h14"/></svg>',
    check: '<svg viewBox="0 0 24 24"><path d="m5 12.5 4.2 4.2L19 7"/></svg>',
    close: '<svg viewBox="0 0 24 24"><path d="m6 6 12 12M18 6 6 18"/></svg>'
  };
  const lbl = x => { const s = (x || '').toLowerCase(); if (s === 'couleur or' || s === 'or') return 'Or'; if (s === 'couleur argent' || s === 'argent') return 'Argent'; if (s.includes('or et argent')) return 'Or & argent'; return x; };
  const metalOfVal = x => { const l = lbl(x); return l === 'Or' ? 'or' : l === 'Argent' ? 'argent' : null; };
  const sized = (u, w) => (u ? u + (u.includes('?') ? '&' : '?') + 'width=' + w : '');

  /* ---------- header ---------- */
  const cap = $('#cap');
  if (cap) {
    const onScroll = () => cap.classList.toggle('sc', scrollY > 40);
    addEventListener('scroll', onScroll, { passive: true }); onScroll();
  }

  /* ---------- overlays ---------- */
  let openEl = null, lastFocus = null;
  function openOv(id) {
    closeOv(true);
    const el = document.getElementById(id); if (!el) return;
    lastFocus = document.activeElement; openEl = el;
    el.classList.add('on'); el.setAttribute('aria-hidden', 'false'); document.body.classList.add('lock');
    if (id === 'search') renderSearch();
    setTimeout(() => (el.querySelector('input[type=search]') || el.querySelector('.x'))?.focus({ preventScroll: true }), 90);
  }
  function closeOv(silent) {
    if (!openEl) return;
    const el = openEl; openEl = null;
    el.classList.remove('on'); el.setAttribute('aria-hidden', 'true'); document.body.classList.remove('lock');
    if (!silent) lastFocus?.focus?.({ preventScroll: true });
  }
  document.addEventListener('click', e => {
    const o = e.target.closest('[data-open]');
    if (o) {
      if (o.dataset.open === 'cart' && document.body.classList.contains('p-cart')) return; /* déjà sur /cart */
      e.preventDefault(); openOv(o.dataset.open); return;
    }
    if (e.target.closest('[data-close]')) closeOv();
  });
  addEventListener('keydown', e => { if (e.key === 'Escape') closeOv(); });

  /* ---------- toast ---------- */
  const toastEl = $('#toast'); let tt;
  function toast(msg) {
    if (!toastEl) return;
    toastEl.innerHTML = IC.check + '<span>' + msg + '</span>'; toastEl.classList.add('on');
    clearTimeout(tt); tt = setTimeout(() => toastEl.classList.remove('on'), 2600);
  }

  /* ---------- teinte or / argent ---------- */
  const metal_ = () => (html.dataset.metal === 'argent' ? 'argent' : 'or');
  function syncUI() {
    const m = metal_();
    $$('.mt button').forEach(b => b.setAttribute('aria-checked', b.dataset.metal === m));
    $$('[data-other]').forEach(x => (x.textContent = m === 'or' ? 'argent' : 'or'));
    $$('.pc').forEach(c => { const cm = c.dataset.m || m; $$('.pc-sw button', c).forEach(b => b.classList.toggle('on', b.dataset.sw === cm)); });
  }
  function applyMetal(root = document, animate = false) {
    let n = 0;
    $$('img[data-src-or]', root).forEach(img => {
      const card = img.closest('.pc'), m = (card && card.dataset.m) || metal_(), k = m === 'argent' ? 'ag' : 'or';
      if (img.dataset.cur === k) return;
      const first = img.dataset.cur === undefined && k === 'or';
      img.dataset.cur = k; if (first) return;
      const swap = () => { img.src = img.dataset['src' + (k === 'ag' ? 'Ag' : 'Or')]; img.srcset = img.dataset['srcset' + (k === 'ag' ? 'Ag' : 'Or')]; };
      const r = animate && !reduce.matches ? img.getBoundingClientRect() : null;
      if (!r || r.bottom < -40 || r.top > innerHeight + 40 || !r.width) return swap();
      const box = img.closest('.pc-m') || img.parentElement, d = Math.min(n++, 20) * 30;
      box.style.setProperty('--dl', d + 'ms'); box.classList.remove('glint'); void box.offsetWidth; box.classList.add('glint');
      setTimeout(() => box.classList.remove('glint'), d + 950); setTimeout(swap, d + 140);
    });
    syncUI();
  }
  function setMetal(m) {
    if (m === metal_()) return;
    html.dataset.metal = m; store.set('bjm2-metal', m);
    $$('.pc[data-m]').forEach(c => delete c.dataset.m);
    applyMetal(document, true);
    dispatchEvent(new CustomEvent('metal', { detail: m }));
  }
  document.addEventListener('click', e => {
    const b = e.target.closest('.mt button'); if (b) { setMetal(b.dataset.metal); return; }
    const sw = e.target.closest('.pc-sw button'); if (sw) { const c = sw.closest('.pc'); c.dataset.m = sw.dataset.sw; applyMetal(c, true); }
  });
  const coin = $('#coin');
  coin?.addEventListener('click', () => { coin.classList.remove('spin'); void coin.offsetWidth; coin.classList.add('spin'); setMetal(metal_() === 'or' ? 'argent' : 'or'); coin.classList.remove('hint'); });
  if (coin && !store.get('bjm2-coin', 0)) { setTimeout(() => coin.classList.add('hint'), 1600); setTimeout(() => coin.classList.remove('hint'), 5200); store.set('bjm2-coin', 1); }
  { let ly = scrollY; addEventListener('scroll', () => { const y = scrollY; if (Math.abs(y - ly) > 8) { coin?.classList.toggle('away', mobile.matches && y > ly && y > 300); ly = y; } }, { passive: true }); }
  applyMetal();

  /* ---------- panier (API AJAX Shopify) ---------- */
  async function refreshCart(bump) {
    const cur = $('#cart'); if (!cur) return;
    let nu = null;
    try {
      const r = await fetch(R.root + '?sections=cart-drawer', { headers: { Accept: 'application/json' } });
      const j = await r.json();
      nu = new DOMParser().parseFromString(j['cart-drawer'], 'text/html').querySelector('#cart');
    } catch (e) {}
    if (!nu) return;
    cur.innerHTML = nu.innerHTML;
    cur.classList.toggle('is-empty', nu.classList.contains('is-empty'));
    const n = +nu.dataset.count || 0;
    $$('[data-cartn]').forEach(c => { c.textContent = n; c.classList.toggle('has', n > 0); if (bump) { c.classList.remove('bump'); void c.offsetWidth; c.classList.add('bump'); } });
  }
  function fly(img, done) {
    const tgt = $('.cap-cart'); if (!tgt) return done();
    const a = img.getBoundingClientRect(), b = tgt.getBoundingClientRect();
    if (!a.width || a.bottom < 0 || a.top > innerHeight) return done();
    const f = document.createElement('img'); f.src = img.currentSrc || img.src; f.className = 'fly';
    f.style.cssText = 'left:' + a.left + 'px;top:' + a.top + 'px;width:' + a.width + 'px;height:' + a.height + 'px';
    document.body.appendChild(f);
    requestAnimationFrame(() => requestAnimationFrame(() => {
      f.style.transform = 'translate(' + (b.left + b.width / 2 - a.left - a.width / 2) + 'px,' + (b.top + b.height / 2 - a.top - a.height / 2) + 'px) scale(' + Math.max(.06, 26 / a.width) + ') rotate(20deg)';
      f.style.opacity = '.3';
    }));
    setTimeout(() => { f.remove(); done(); }, 720);
  }
  async function addToCart(id, q = 1, fromImg, open = true) {
    let r;
    try {
      r = await fetch(R.cartAdd + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: +id, quantity: q }] }) });
    } catch (e) { toast('Connexion impossible, réessayez.'); return false; }
    if (!r.ok) { const e = await r.json().catch(() => ({})); toast(esc(e.description || 'Impossible d’ajouter ce bijou')); return false; }
    const go = async () => { await refreshCart(true); if (open && $('#cart') && !document.body.classList.contains('p-cart')) openOv('cart'); else if (document.body.classList.contains('p-cart')) location.reload(); };
    fromImg && !reduce.matches ? fly(fromImg, go) : go();
    return true;
  }
  async function changeLine(li, qty) {
    qty = Math.max(0, Math.min(99, qty));
    if (qty === 0) { li.classList.add('rm'); await new Promise(r => setTimeout(r, 300)); }
    try { await fetch(R.cartChange + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line: +li.dataset.line, quantity: qty }) }); } catch (e) {}
    await refreshCart();
  }
  document.addEventListener('click', e => {
    const d = e.target.closest('#cart [data-d]');
    if (d) { const li = d.closest('.line'); const cur = +li.querySelector('.mq span').textContent; changeLine(li, cur + (+d.dataset.d)); return; }
    const rm = e.target.closest('#cart .l-rm'); if (rm) { changeLine(rm.closest('.line'), 0); return; }
    const up = e.target.closest('[data-up]'); if (up) { addToCart(up.dataset.up, 1, null, true); toast('Ajouté au panier'); }
  });

  /* ---------- ajout rapide ---------- */
  const quick = $('#quick');
  const tile = u => '<span class="t"><img src="' + esc(u) + '" alt="" loading="lazy"></span>';
  async function quickAdd(handle, fromImg, metal, single) {
    if (single) return addToCart(single, 1, fromImg);
    let p;
    try { p = await (await fetch(R.root + 'products/' + handle + '.js')).json(); } catch (e) { location.href = R.root + 'products/' + handle; return; }
    const names = p.options.map(o => (typeof o === 'string' ? o : o.name));
    const opts = names.map((name, oi) => ({ name, oi, vals: [...new Set(p.variants.map(v => v.options[oi]))] })).filter(x => x.vals.length > 1);
    const pool = p.variants.filter(v => v.available).length ? p.variants.filter(v => v.available) : p.variants;
    let cur = pool.find(v => v.options.some(o => metalOfVal(o) === (metal || metal_()))) || pool[0];
    if (!opts.length) { if (!cur.available) return toast('Ce bijou est épuisé'); return addToCart(cur.id, 1, fromImg); }
    let sel = [...cur.options];
    const findV = s => p.variants.find(v => s.every((x, i) => x == null || v.options[i] === x));
    const draw = () => {
      const v = findV(sel) || cur; cur = v;
      const im = (v.featured_image && v.featured_image.src) || p.featured_image;
      quick.innerHTML = '<div class="qs"><div class="qs-hd">' + tile(sized(im, 480)) + '<div><small>' + esc(p.type || '') + '</small><b>' + esc(p.title) + '</b><span class="price">' + money(v.price) + (v.compare_at_price > v.price ? ' <s>' + money(v.compare_at_price) + '</s>' : '') + '</span></div><button class="x" type="button" data-close aria-label="Fermer">' + IC.close + '</button></div>'
        + opts.map(({ name, oi, vals }) => {
          const isCol = /^(couleur|color)$/i.test(name);
          return '<div class="op"><p class="op-l"><span>' + esc(name) + '</span><b>' + esc(lbl(sel[oi])) + '</b>' + (/^taille$/i.test(name) && /bague/i.test(p.title) ? '<button type="button" class="lnk sm" data-open="sizes">Guide des tailles</button>' : '') + '</p><div class="op-v ' + (isCol ? 'op-c' : 'op-p') + '" role="radiogroup">'
            + vals.map(x => {
              const L = lbl(x), m = metalOfVal(x) || (L === 'Or & argent' ? 'mix' : ''), t = [...sel]; t[oi] = x;
              const ok = (findV(t) || {}).available;
              return '<button type="button" role="radio" aria-checked="' + (x === sel[oi]) + '" data-oi="' + oi + '" data-v="' + esc(x) + '" class="' + (isCol && m ? 'm-' + m : '') + (ok ? '' : ' na') + '">' + (isCol ? '<i></i>' : '') + '<span>' + esc(L) + '</span></button>';
            }).join('') + '</div></div>';
        }).join('')
        + '<button type="button" class="pill pill-xl" data-go' + (v.available ? '' : ' disabled') + '>' + (v.available ? 'Ajouter · ' + money(v.price) : 'Épuisé') + '</button><a class="lnk" href="' + R.root + 'products/' + p.handle + '">Voir la fiche produit</a></div>';
    };
    draw();
    quick.onclick = e => {
      const b = e.target.closest('[data-oi]');
      if (b) { sel[+b.dataset.oi] = b.dataset.v; if (!findV(sel)) { const alt = p.variants.find(v => v.options[+b.dataset.oi] === b.dataset.v); if (alt) sel = [...alt.options]; } draw(); return; }
      if (e.target.closest('[data-go]')) { const img = $('.t img', quick); closeOv(true); addToCart(cur.id, 1, img); }
    };
    openOv('quick');
  }
  document.addEventListener('click', e => {
    const a = e.target.closest('[data-add]'); if (!a) return; e.preventDefault();
    const c = a.closest('.pc'); quickAdd(a.dataset.add, c ? c.querySelector('.i1') : null, c && c.dataset.m, a.dataset.single);
  });

  /* ---------- recherche prédictive ---------- */
  const qEl = $('#q'); let sSeq = 0;
  async function renderSearch() {
    if (!qEl) return;
    const q = qEl.value.trim(), res = $('.sr-res'), n = $('.sr-n'), seq = ++sSeq;
    if (!q) { n.textContent = 'Commencez à écrire pour rechercher…'; res.innerHTML = ''; return; }
    let items = [];
    try {
      const r = await fetch(R.predictive + '.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=8&resources[options][unavailable_products]=last');
      const j = await r.json(); items = (j.resources && j.resources.results && j.resources.results.products) || [];
    } catch (e) {}
    if (seq !== sSeq) return;
    n.innerHTML = items.length ? 'Résultats pour « ' + esc(q) + ' » · <a class="lnk sm" href="' + R.search + '?q=' + encodeURIComponent(q) + '">Tout voir</a>' : 'Aucun résultat pour « ' + esc(q) + ' ». Essayez « créoles », « cœur » ou « jonc ».';
    res.innerHTML = items.map(p => {
      const im = (p.featured_image && p.featured_image.url) || p.image || '';
      return '<article class="pc"><div class="pc-m"><a class="pc-a" href="' + esc(p.url) + '" aria-label="' + esc(p.title) + '">' + (im ? '<img class="i1" src="' + esc(sized(im, 480)) + '" alt="' + esc(p.title) + '" loading="lazy">' : '') + '</a></div><div class="pc-t"><a class="pc-n" href="' + esc(p.url) + '"><h3>' + esc(p.title) + '</h3></a><p class="pc-pr">' + money(Math.round(parseFloat(p.price) * 100)) + '</p></div></article>';
    }).join('');
  }
  let sT; qEl?.addEventListener('input', () => { clearTimeout(sT); sT = setTimeout(renderSearch, 160); });
  $('.sr-sug')?.addEventListener('click', e => { const b = e.target.closest('[data-q]'); if (b) { qEl.value = b.dataset.q; renderSearch(); qEl.focus(); } });

  /* ---------- page collection : tri ---------- */
  $('[data-sort]')?.addEventListener('change', e => {
    const u = new URL(location.href); u.searchParams.set('sort_by', e.target.value); u.searchParams.delete('page'); location.href = u.toString();
  });

  /* ---------- page produit : variantes ---------- */
  $$('[data-product-section]').forEach(sec => {
    const dataEl = $('[data-product-json]', sec), form = $('.pdp-form', sec);
    if (!dataEl || !form) return;
    const data = JSON.parse(dataEl.textContent);
    const idEl = $('[data-variant-id]', form), btn = $('[data-add-btn]', form), price = $('[data-price]', sec), comp = $('[data-compare]', sec);
    let sel = [...(data.variants.find(v => v.id === +idEl.value) || data.variants[0]).options];
    const findV = s => data.variants.find(v => s.every((x, i) => v.options[i] === x));
    const paint = () => {
      const v = findV(sel) || data.variants[0];
      $$('.op', form).forEach(op => {
        const first = $('[data-oi]', op); if (!first) return; const oi = +first.dataset.oi;
        $$('button[data-v]', op).forEach(b => {
          b.setAttribute('aria-checked', b.dataset.v === sel[oi]);
          const t = [...sel]; t[oi] = b.dataset.v;
          b.classList.toggle('na', !data.variants.some(x => x.available && t.every((y, i) => x.options[i] === y)));
        });
        const l = $('[data-sel-label]', op); if (l) l.textContent = lbl(sel[oi]);
      });
      idEl.value = v.id;
      if (price) price.textContent = money(v.price);
      if (comp) { comp.hidden = !(v.compare_at_price > v.price); comp.textContent = v.compare_at_price > v.price ? money(v.compare_at_price) : ''; }
      btn.disabled = !v.available; btn.textContent = v.available ? 'Ajouter · ' + money(v.price) : 'Épuisé';
      const u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u.toString());
      const mid = v.featured_media && v.featured_media.id;
      if (mid) { const m = $('.pdp-m[data-media-id="' + mid + '"]', sec); if (m) { $$('.pdp-m', sec).forEach(x => x.classList.toggle('on', x === m)); m.scrollIntoView({ behavior: reduce.matches ? 'auto' : 'smooth', block: 'nearest' }); } }
    };
    form.addEventListener('click', e => {
      const b = e.target.closest('button[data-oi]'); if (!b) return;
      sel[+b.dataset.oi] = b.dataset.v;
      if (!findV(sel)) { const alt = data.variants.find(v => v.options[+b.dataset.oi] === b.dataset.v); if (alt) sel = [...alt.options]; }
      paint();
    });
    form.addEventListener('submit', e => { e.preventDefault(); if (btn.disabled) return; addToCart(idEl.value, 1, $('.pdp-m.on img', sec) || $('.pdp-m img', sec)); });
    paint();
  });

  /* ---------- accueil : hero 3D, chiffres ---------- */
  const hx = $('.hx');
  if (hx) {
    new IntersectionObserver(([e]) => document.body.classList.toggle('hero-on', e.intersectionRatio > .35), { threshold: [0, .35, .6] }).observe(hx);
    const host = $('#gl'), url = hx.dataset.rings;
    if (host && url) {
      const start = () => import(url).then(m => {
        const api = m.mountRings(host, { metal: metal_(), compact: mobile.matches });
        addEventListener('metal', e => api && api.setMetal && api.setMetal(e.detail));
      }).catch(() => host.classList.add('no-gl'));
      'requestIdleCallback' in window ? requestIdleCallback(start, { timeout: 600 }) : setTimeout(start, 60);
    } else if (host) host.classList.add('no-gl');
  }
  {
    const els = $$('.st b[data-n]');
    if (els.length) {
      const io = new IntersectionObserver(es => es.forEach(e => {
        if (!e.isIntersecting) return; io.unobserve(e.target);
        const el = e.target, n = +el.dataset.n; if (reduce.matches || !n) return;
        const t0 = performance.now();
        const step = t => { const k = Math.min(1, (t - t0) / 1100); el.textContent = Math.round(n * (1 - Math.pow(1 - k, 3))); if (k < 1) requestAnimationFrame(step); };
        el.textContent = '0'; requestAnimationFrame(step);
      }), { threshold: .6 });
      els.forEach(el => io.observe(el));
    }
  }


  /* ---------- « Pensés pour durer » : histoires ---------- */
  {
    const sec = $('.proof');
    if (sec) {
      const bars = $$('.prog i', sec), ss = $$('.ps', sec); let i = 0;
      const show = k => { i = k; bars.forEach((b, j) => { b.classList.toggle('done', j < k); b.classList.remove('on'); }); void bars[k].offsetWidth; bars[k].classList.add('on'); ss.forEach((x, j) => x.classList.toggle('on', j === k)); };
      if (ss.length) {
        bars.forEach(b => b.querySelector('b').addEventListener('animationend', () => show((i + 1) % ss.length)));
        $('.proof-card', sec).addEventListener('click', e => { if (e.target.closest('a')) return; show((i + 1) % ss.length); });
        new IntersectionObserver(([e]) => sec.classList.toggle('paused', !e.isIntersecting), { threshold: .3 }).observe(sec);
        show(0);
      }
      const v = $('video', sec);
      if (v) new IntersectionObserver(([e]) => { if (e.isIntersecting) { if (!reduce.matches) v.play().catch(() => {}); } else v.pause(); }, { rootMargin: '300px 0px' }).observe(v);
    }
  }

  /* ---------- avis ---------- */
  {
    const qs = $$('#quotes .q'), nav = $$('.q-nav button'); let i = 0, t;
    const show = k => { i = k; qs.forEach((q, j) => q.classList.toggle('on', j === k)); nav.forEach((b, j) => b.classList.toggle('on', j === k)); };
    nav.forEach((b, k) => b.addEventListener('click', () => { show(k); clearInterval(t); }));
    if (qs.length > 1) t = setInterval(() => show((i + 1) % qs.length), 6500);
  }

  /* ---------- moodboard : défilement à la souris ---------- */
  function dragScroll(el) {
    if (!el || el._d) return; el._d = 1;
    let down = false, sx = 0, sl = 0, lx = 0, vx = 0, lt = 0, moved = false, raf;
    el.addEventListener('pointerdown', e => { if (e.pointerType !== 'mouse' || e.button) return; down = true; moved = false; sx = lx = e.clientX; sl = el.scrollLeft; vx = 0; lt = performance.now(); cancelAnimationFrame(raf); });
    addEventListener('pointermove', e => { if (!down) return; const dx = e.clientX - sx; if (Math.abs(dx) > 5 && !moved) { moved = true; el.classList.add('drag'); } if (!moved) return; const t = performance.now(); vx = (e.clientX - lx) / Math.max(1, t - lt); lx = e.clientX; lt = t; el.scrollLeft = sl - dx; });
    addEventListener('pointerup', () => { if (!down) return; down = false; if (!moved) return; let v = vx * 16; const step = () => { v *= .94; el.scrollLeft -= v; if (Math.abs(v) > .4) raf = requestAnimationFrame(step); else el.classList.remove('drag'); }; raf = requestAnimationFrame(step); setTimeout(() => el.classList.remove('drag'), 700); });
    el.addEventListener('click', e => { if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; } }, true);
  }
  dragScroll($('#board'));


  /* ---------- ajout groupé (trio) ---------- */
  async function addItems(ids) {
    let r;
    try { r = await fetch(R.cartAdd + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: ids.map(id => ({ id: +id, quantity: 1 })) }) }); } catch (e) { toast('Connexion impossible, réessayez.'); return false; }
    if (!r.ok) { const e = await r.json().catch(() => ({})); toast(esc(e.description || 'Impossible d’ajouter ces bijoux')); return false; }
    await refreshCart(true);
    if (document.body.classList.contains('p-cart')) location.reload(); else openOv('cart');
    return true;
  }

  /* ---------- contrôle segmenté ---------- */
  const knob = sg => { const k = $('.sg-k', sg), b = $('button.on', sg); if (!k || !b) return; k.style.width = b.offsetWidth + 'px'; k.style.transform = 'translateX(' + b.offsetLeft + 'px)'; };
  const segOn = (sg, btn) => { $$('button', sg).forEach(x => { const on = x === btn; x.classList.toggle('on', on); x.setAttribute('aria-selected', on); }); knob(sg); };
  { const allKnobs = () => $$('.sg').forEach(knob); allKnobs(); addEventListener('resize', allKnobs); document.fonts && document.fonts.ready.then(allKnobs); setTimeout(allKnobs, 400); }

  /* ---------- onglets de catégories (cycle automatique) ---------- */
  {
    const sec = $('.pres');
    if (sec) {
      const tabs = $$('.pres-tabs button', sec), panes = $$('.pres-p', sec); let i = 0, timer, vis = false;
      const DUR = 6000; sec.style.setProperty('--dur', DUR + 'ms');
      const show = k => { i = k; tabs.forEach((t, j) => { t.classList.toggle('on', j === k); t.setAttribute('aria-selected', j === k); }); panes.forEach((x, j) => x.classList.toggle('on', j === k)); };
      const run = () => { clearInterval(timer); if (vis && tabs.length > 1 && !sec.classList.contains('paused')) timer = setInterval(() => show((i + 1) % tabs.length), DUR); };
      tabs.forEach((t, k) => t.addEventListener('click', () => { sec.classList.add('paused'); show(k); clearInterval(timer); }));
      new IntersectionObserver(([e]) => { vis = e.isIntersecting; run(); }, { threshold: .35 }).observe(sec);
    }
  }

  /* ---------- machine à empiler (trio) ---------- */
  {
    const sec = $('.mach'), dEl = $('[data-trio-data]');
    if (sec && dEl) {
      const D = JSON.parse(dEl.textContent), BY = Object.fromEntries(D.p.map(p => [p.h, p]));
      const reels = $('#reels'), stack = $('#stack'), sg = $('.mach-sg'), tot = $('#trioTot');
      const wd = (u, w) => (u || '').replace(/([?&])width=\d+/, '$1width=' + w);
      const vr = (p, m) => (m === 'argent' ? p.a : p.o);
      const COPY = { j: [sec.dataset.hj, sec.dataset.pj], t: [sec.dataset.ht, sec.dataset.pt] };
      D.pool = D.pool.filter(h => BY[h]); D.j = D.j.filter(h => BY[h]); D.t = D.t.filter(h => BY[h]);
      while (D.j.length < 3 && D.pool.length) D.j.push(D.pool[(D.j.length * 5) % D.pool.length]);
      if (D.j.length === 3) {
        if (D.t.length < 3) { const tb = $('[data-trio="t"]', sg); tb && tb.remove(); }
        let mode = 'j', picks = [...D.j], lists = [];
        const item = h => { const p = BY[h]; return '<button type="button" class="reel-i" data-s="' + esc(h) + '"><span class="t"><img src="' + esc(wd(vr(p, metal_())[1], 480)) + '" alt="" loading="lazy" draggable="false"></span><small>' + esc(p.n.replace(/^Bracelet /, '')) + '</small></button>'; };
        const pad = s => { const it = $('.reel-i', s); if (!it) return; const p = Math.max(0, (s.clientHeight - it.offsetHeight) / 2); s.style.padding = p + 'px 10px'; };
        const mark = (s, k) => $$('.reel-i', s).forEach((b, j) => b.classList.toggle('on', j === k));
        const centerOn = (s, k, smooth) => { const it = $$('.reel-i', s)[k]; if (!it) return; s.scrollTo({ top: it.offsetTop - (s.clientHeight - it.offsetHeight) / 2, behavior: smooth && !reduce.matches ? 'smooth' : 'instant' }); if (!smooth) mark(s, k); };
        const nearest = s => { const c = s.scrollTop + s.clientHeight / 2; let best = 0, d = 1e9; $$('.reel-i', s).forEach((b, j) => { const dd = Math.abs(b.offsetTop + b.offsetHeight / 2 - c); if (dd < d) { d = dd; best = j; } }); return best; };
        const drawStack = changed => {
          const W = stack.clientWidth, H = stack.clientHeight;
          if (stack.children.length !== 3) stack.innerHTML = [0, 1, 2].map(i => '<div class="stk" data-i="' + i + '"><img alt=""></div>').join('');
          $$('.stk', stack).forEach((el, i) => {
            const p = BY[picks[i]], img = $('img', el), ns = wd(vr(p, metal_())[1], 960);
            if (img.getAttribute('src') !== ns) img.src = ns;
            const w = mode === 'j' ? Math.min(W * .74, H * .6) : Math.min(W * .5, H * .46), h = w * 1.25;
            let x = W / 2, y, r;
            if (mode === 'j') { y = (H - h) / 2 + (i - 1) * h * .24; r = [-5, 3, -2][i]; }
            else { [x, y, r] = [[W * .5, H * .02, 0], [W * .28, H - h - H * .04, -6], [W * .72, H - h - H * .08, 6]][i]; }
            el.style.cssText = 'width:' + w + 'px;left:' + x + 'px;top:' + y + 'px;z-index:' + (i + 1) + ';transform:translate(-50%,0) rotate(' + r + 'deg)';
            if (changed === i) { el.classList.remove('pop'); void el.offsetWidth; el.classList.add('pop'); }
          });
          tot.textContent = money(picks.reduce((a, h) => a + BY[h].pr, 0));
        };
        const settle = i => { const s = $$('.reel-s', reels)[i]; if (!s || s.classList.contains('spin')) return; const k = nearest(s); mark(s, k); const ns = lists[i][k]; if (ns !== picks[i]) { picks[i] = ns; drawStack(i); } };
        const settleAll = () => { $$('.reel-s', reels).forEach((s, i) => { const k = mode === 'j' ? nearest(s) : 0; mark(s, k); picks[i] = lists[i][k]; }); drawStack(); };
        const build = () => {
          lists = mode === 'j' ? [0, 1, 2].map(() => D.pool) : D.t.map(h => [h]);
          reels.classList.toggle('fixed', mode === 't'); sec.classList.toggle('t-mode', mode === 't');
          reels.innerHTML = lists.map((l, i) => '<div class="reel" data-r="' + i + '"><span class="reel-n">0' + (i + 1) + '</span><div class="reel-s">' + l.map(item).join('') + '</div><i class="reel-w"></i></div>').join('');
          $$('.reel', reels).forEach((r, i) => { const s = $('.reel-s', r); pad(s); centerOn(s, Math.max(0, lists[i].indexOf(picks[i])), false); s.addEventListener('scroll', () => { clearTimeout(s._t); s._t = setTimeout(() => settle(i), 110); }, { passive: true }); $$('.reel-i', s).forEach((b, k) => b.addEventListener('click', () => centerOn(s, k, true))); });
          settleAll(); $('#trioH').textContent = COPY[mode][0]; $('#trioP').textContent = COPY[mode][1];
        };
        $('#shuffle').addEventListener('click', () => {
          if (mode !== 'j') return;
          const n = D.pool.length, used = new Set();
          $$('.reel-s', reels).forEach((s, i) => {
            let k; do { k = Math.floor(Math.random() * n); } while (used.has(k) && used.size < n); used.add(k);
            const it = $$('.reel-i', s)[k]; s.classList.add('spin');
            setTimeout(() => { s.scrollTo({ top: it.offsetTop - (s.clientHeight - it.offsetHeight) / 2, behavior: reduce.matches ? 'instant' : 'smooth' }); }, i * 160);
            setTimeout(() => { s.classList.remove('spin'); mark(s, k); picks[i] = D.pool[k]; drawStack(i); }, 900 + i * 160);
          });
        });
        sg.addEventListener('click', e => { const b = e.target.closest('[data-trio]'); if (!b || b.dataset.trio === mode) return; segOn(sg, b); mode = b.dataset.trio; picks = [...D[mode]]; stack.innerHTML = ''; build(); });
        $('#trioAdd').addEventListener('click', async () => {
          const ok = await addItems(picks.map(h => vr(BY[h], metal_())[0]));
          if (ok) toast('Le trio est dans votre panier');
        });
        addEventListener('metal', () => { $$('.reel-i', reels).forEach(b => { const img = $('img', b); img.src = wd(vr(BY[b.dataset.s], metal_())[1], 480); }); drawStack(); });
        let rw = 0;
        new ResizeObserver(() => { if (Math.abs(reels.clientWidth - rw) < 2) return drawStack(); rw = reels.clientWidth; $$('.reel-s', reels).forEach((s, i) => { pad(s); centerOn(s, Math.max(0, lists[i].indexOf(picks[i])), false); }); drawStack(); }).observe(stack);
        build();
      }
    }
  }

  /* ---------- pierre de naissance ---------- */
  {
    const sec = $('#gem'), dEl = sec && $('[data-gem-data]', sec);
    if (sec && dEl) {
      const G = JSON.parse(dEl.textContent), img = $('#gemImg'), btn = $('#gemAdd');
      let cur = +sec.dataset.start || 0, auto = true, timer;
      G.forEach(g => { if (g.i) { const im = new Image(); im.src = g.i; } });
      const set = (k, user, init) => {
        if (user) { auto = false; clearInterval(timer); }
        cur = k; const g = G[k];
        $$('.mo', sec).forEach(m => { const on = +m.dataset.i === k; m.classList.toggle('on', on); m.setAttribute('aria-checked', on); });
        sec.style.setProperty('--g', g.c); $('#gemM').textContent = g.m; $('#gemS').textContent = g.s; $('#gemP').textContent = money(g.p);
        btn.dataset.v = g.v; btn.disabled = !g.a; btn.textContent = (g.a ? 'Ajouter — ' : 'Épuisé — ') + g.m;
        if (g.i && img.getAttribute('src') !== g.i) {
          const swapImg = () => { img.src = g.i; img.alt = 'Collier pierre de naissance — ' + g.m; img.classList.remove('sw'); };
          if (init) swapImg(); else { img.classList.add('sw'); setTimeout(swapImg, 220); }
        }
        if (user && mobile.matches) $$('.mo', sec)[k].scrollIntoView({ inline: 'center', block: 'nearest', behavior: 'smooth' });
      };
      set(cur, false, true);
      $('.months', sec).addEventListener('click', e => { const b = e.target.closest('.mo'); if (b) set(+b.dataset.i, true); });
      btn.addEventListener('click', () => { if (!btn.dataset.v) return; addToCart(btn.dataset.v, 1, img); auto = false; clearInterval(timer); });
      new IntersectionObserver(([e]) => { clearInterval(timer); if (e.isIntersecting && auto && !reduce.matches) timer = setInterval(() => set((cur + 1) % 12), 2600); }, { threshold: .4 }).observe(sec);
    }
  }

  window.BJM.api = { addToCart, addItems, openOv, closeOv, toast, refreshCart, setMetal };
})();
